import { RouteStatus } from '../types';

/** См. `getStatusLabel` / `StatusTag` — дублирует подписи для переходов и legacy. */
export const statusLabels: Record<RouteStatus, string> = {
	[RouteStatus.CREATED]: 'Создан',
	[RouteStatus.IN_TRANSIT]: 'В пути',
	[RouteStatus.READY_FOR_COMPLETION]: 'Готов к завершению',
	[RouteStatus.ISSUES]: 'Проблемы',
	[RouteStatus.COMPLETED]: 'Завершён',
	[RouteStatus.CANCELLED]: 'Отменён',
};

export const statusColors: Record<RouteStatus, string> = {
	[RouteStatus.CREATED]: 'orange',
	[RouteStatus.IN_TRANSIT]: 'blue',
	[RouteStatus.READY_FOR_COMPLETION]: 'gold',
	[RouteStatus.ISSUES]: 'red',
	[RouteStatus.COMPLETED]: 'green',
	[RouteStatus.CANCELLED]: 'default',
};

export const normalizeRouteStatus = (status?: string | RouteStatus): RouteStatus | null => {
	if (!status) return null;
	const s = String(status).toLowerCase();
	if (s === RouteStatus.CREATED) return RouteStatus.CREATED;
	if (s === RouteStatus.IN_TRANSIT) return RouteStatus.IN_TRANSIT;
	if (s === RouteStatus.READY_FOR_COMPLETION) return RouteStatus.READY_FOR_COMPLETION;
	if (s === RouteStatus.ISSUES) return RouteStatus.ISSUES;
	if (s === RouteStatus.COMPLETED) return RouteStatus.COMPLETED;
	if (s === RouteStatus.CANCELLED) return RouteStatus.CANCELLED;
	return null;
};

export const getAllowedStatusTransitions = (currentStatus: RouteStatus): RouteStatus[] => {
	const transitions: Record<RouteStatus, RouteStatus[]> = {
		[RouteStatus.CREATED]: [RouteStatus.IN_TRANSIT, RouteStatus.CANCELLED],
		[RouteStatus.IN_TRANSIT]: [RouteStatus.ISSUES, RouteStatus.CANCELLED],
		[RouteStatus.READY_FOR_COMPLETION]: [RouteStatus.ISSUES, RouteStatus.CANCELLED],
		[RouteStatus.ISSUES]: [RouteStatus.IN_TRANSIT, RouteStatus.CANCELLED],
		[RouteStatus.COMPLETED]: [],
		[RouteStatus.CANCELLED]: [],
	};
	return transitions[currentStatus] || [];
};

export const statusOrder: Record<RouteStatus, number> = {
	[RouteStatus.CREATED]: 1,
	[RouteStatus.IN_TRANSIT]: 2,
	[RouteStatus.ISSUES]: 3,
	[RouteStatus.READY_FOR_COMPLETION]: 4,
	[RouteStatus.COMPLETED]: 5,
	[RouteStatus.CANCELLED]: 6,
};






